module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-bodymatter element-container-single element-type-chapter element-with-heading full-character-formatting",
    attrs: {
      "id": "vol-1-unnumbered-1"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image"
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title case-upper"
  }, [_vm._v("FATAL INSOMNIA MEDICAL THRILLERS")])]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle case-mixed"
  }, [_vm._v("What Keeps You Awake at Night?")])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "vol-1-unnumbered-1-text"
    }
  }, [_c('div', {
    staticClass: "inline-image inline-image-kind-photograph inline-image-size-large inline-image-flow-center inline-image-flow-within-text inline-image-aspect-wide inline-image-without-caption inline-image-begins-section inline-image-before-element-end"
  }, [_c('div', {
    staticClass: "inline-image-container"
  }, [_c('a', {
    staticClass: "link-contains-image",
    attrs: {
      "href": "https://cjlyons.net/fatalinsomnia/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Fatal Insomnia Medical Thrillers",
      "src": "images/fatalinsomnia3book.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "https://cjlyons.net/fatalinsomnia/",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_vm._v("FAREWELL TO DREAMS,")]), _vm._v(" Fatal Insomnia Book #1")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "https://cjlyons.net/fatalinsomnia/",
      "target": "_blank"
    }
  }, [_vm._v("A RAGING DAWN, Fatal Insomnia Book #2")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "https://cjlyons.net/fatalinsomnia/",
      "target": "_blank"
    }
  }, [_vm._v("THE SLEEPLESS STARS, Fatal Insomnia Book #3")])]), _vm._v(" "), _c('div', {
    staticClass: "alignment-block alignment-block-align-center"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_vm._v("Based on a real-life disease that promises a horrifying death, CJ’s Fatal Insomnia series chronicles one doctor’s search for redemption, hope, and an unexpected chance at love.")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_c('i', [_vm._v("She might be dying, but she’s finally learning how to live…")])])])]), _vm._v(" "), _c('div', {
    staticClass: "blockquote-container prose without-attribution"
  }, [_c('blockquote', {
    staticClass: "prose without-attribution"
  }, [_c('div', {
    staticClass: "blockquote-image-block blockquote-image-aspect-wide"
  }, [_c('div', {
    staticClass: "blockquote-image-size-container"
  }, [_c('img', {
    staticClass: "blockquote-image-image",
    attrs: {
      "alt": "",
      "src": "images/blockquote-big-66-screen.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first blockquote-content blockquote-content-prose blockquote-position-first blockquote-position-last"
  }, [_vm._v("CJ Lyons scores a major triumph. Totally absorbing and impossible to put down.” "), _c('i', [_vm._v("~Douglas Preston")])])])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Want to be the first to have a chance to read the new books? Sign up for my "), _c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "http://cjlyons.net/signup",
      "target": "_blank"
    }
  }, [_vm._v("Thrillers with Heart newsletter HERE")]), _vm._v("—and you’ll also get a free copy of the first Lucy adventure, SNAKE SKIN!")]), _vm._v(" "), _c('div', {
    staticClass: "inline-image inline-image-kind-photograph inline-image-size-full inline-image-flow-center inline-image-flow-within-text inline-image-aspect-wide inline-image-without-caption inline-image-after-section-begin inline-image-before-element-end"
  }, [_c('div', {
    staticClass: "inline-image-container"
  }, [_c('a', {
    staticClass: "link-contains-image",
    attrs: {
      "href": "http://cjlyons.net/signup",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "alt": "email signup",
      "src": "images/newmailsignupvellum.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("(Already read SNAKE SKIN? Feel free to share this offer with your thriller-loving friends!)")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Be sure to open the Thrillers with Heart emails; they’ll arrive every few weeks with info on contests, new books, and exclusive offers for my readers!")]), _vm._v(" "), _c('div', {
    staticClass: "inline-image inline-image-kind-freestanding inline-image-size-small inline-image-flow-center inline-image-flow-within-text inline-image-aspect-wide inline-image-without-caption inline-image-after-section-begin"
  }, [_c('div', {
    staticClass: "inline-image-container"
  }, [_c('a', {
    staticClass: "link-contains-image",
    attrs: {
      "href": "http://cjlyons.net/signup",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Thanks for reading! CJ",
      "src": "images/image-300thanks-448.jpg"
    }
  })])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b9ae68ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vol001fatalinsomniamedicalthrillers.vue
// module id = 72
// module chunks = 0